/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Count_TotalInputs */

const cs_count_total = /** @type {(inputs: Count_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Celkem ${i?.count}`)
};

const en_count_total = /** @type {(inputs: Count_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Total {count}" |
*
* @param {Count_TotalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const count_total = /** @type {((inputs: Count_TotalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Count_TotalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_count_total(inputs)
	return cs_count_total(inputs)
});